import { useState } from 'react';
import AdminLayout from '@/components/feature/AdminLayout';
import { adminRequests } from '@/mocks/transactions';

export default function AdminDeposits() {
  const [filter, setFilter] = useState<'all' | 'deposit' | 'withdraw'>('all');
  const filtered = adminRequests.filter((r) => filter === 'all' || r.type === filter);

  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-foreground-950 mb-6">Quản lý yêu cầu nạp / rút</h1>

        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/60 w-fit mb-6">
          {[
            { key: 'all' as const, label: 'Tất cả' },
            { key: 'deposit' as const, label: 'Nạp tiền' },
            { key: 'withdraw' as const, label: 'Rút tiền' },
          ].map((t) => (
            <button key={t.key} onClick={() => setFilter(t.key)} className={`px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors ${filter === t.key ? 'bg-accent-500 text-background-950' : 'text-foreground-600 hover:text-foreground-900'}`}>
              {t.label}
            </button>
          ))}
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="bg-background-100 text-left">
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Người dùng</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Loại</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Số tiền</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Ngân hàng</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Trạng thái</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Thời gian</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id} className="border-t border-background-200/40 hover:bg-background-100/60 transition-colors">
                  <td className="px-4 py-3 font-semibold text-foreground-950 whitespace-nowrap">{r.user}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${r.type === 'deposit' ? 'bg-emerald-500/15 text-emerald-400' : 'bg-rose-500/15 text-rose-400'}`}>
                      {r.type === 'deposit' ? 'Nạp tiền' : 'Rút tiền'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right font-semibold text-foreground-900 whitespace-nowrap">{r.amount.toLocaleString('vi-VN')}đ</td>
                  <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{r.bank}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${
                      r.status === 'approved' ? 'bg-emerald-500/15 text-emerald-400' : r.status === 'pending' ? 'bg-accent-500/15 text-accent-400' : 'bg-rose-500/15 text-rose-400'
                    }`}>
                      {r.status === 'approved' ? 'Đã duyệt' : r.status === 'pending' ? 'Chờ xử lý' : 'Từ chối'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{r.date}</td>
                  <td className="px-4 py-3 text-right whitespace-nowrap">
                    {r.status === 'pending' ? (
                      <div className="flex items-center justify-end gap-2">
                        <button className="px-3 py-1.5 rounded-md bg-emerald-500 text-background-950 text-xs font-semibold cursor-pointer">Duyệt</button>
                        <button className="px-3 py-1.5 rounded-md bg-rose-500 text-background-950 text-xs font-semibold cursor-pointer">Từ chối</button>
                      </div>
                    ) : (
                      <span className="text-xs text-foreground-600">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}